import { render, staticRenderFns } from "./ProductGroupView.vue?vue&type=template&id=3b9d3934&scoped=true&"
import script from "./ProductGroupView.vue?vue&type=script&lang=js&"
export * from "./ProductGroupView.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupView.vue?vue&type=style&index=0&id=3b9d3934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9d3934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VRow})
